<template>
  <div class="que-overflow">
    <span class="article-center-cont" v-html="showWords" />
    <span class="btn" @click="toggleShow" v-if="showAll === false"> <span class="shen">...</span> 展开</span>
    <span class="btn" @click="toggleShow" v-if="showAll === true"> 收起</span>
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  props: {
    words: {
      type: String
    },
    limit: {
      type: Number,
      default: 140
    }
  },
  data () {
    return {
      showWords: '',
      showAll: null
    }
  },
  mounted () {
    this.setWords()
  },
  methods: {
    setWords () {
      if(this.words.length <= this.limit){
        this.showWords = this.words
        this.showAll = null
      }else{
        this.showWords = this.words.slice(0, this.limit)
        this.showAll = false
      }
    },
    toggleShow () {
      if(this.showAll === false){
        this.showWords = this.words
      }else{
        this.showWords = this.words.slice(0, this.limit)
      }
      this.showAll = !this.showAll
    }
  }
}
</script>

<style scoped lang="less">
.que-overflow{
  overflow: auto;
  /deep/.article-center-cont{
    padding: 0;
    *{
      float: none !important;
    }
  }
  line-height: 22px;
  color: #999;
  font-size: 15px;
  .btn{
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    font-weight: bold;
    .shen{
      color: #999;
    }
  }
}
</style>
